
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data: function () {
    return {
      leaderboardData: null,
      loadingPage: false,
      leaderboardPaginations: {
        skip: 0,
        item: 20,
        total: 20
      },
      ptrIsActive: false,
      allowInfinite: true,
      isInfinite: false,
      isMore: true,
      viewMe: false,
      availableBoost: false,
      longPadding: false
    };
  },
  methods: {
    tabShow() {
    },
    scrollToMe(id) {
      if (event.target.classList.contains('flew-up'))
        return false;
      const myId = this.leaderboardData.own_place.id;
      const myIdx = this.leaderboardData.leaderboard.find(el => el.id == myId);
      if (typeof myIdx === 'undefined')
        return false;
      const elem = this.$el.find(`#id-${ myId }`)[0];
      if (typeof elem === 'undefined')
        return false;
      elem.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    },
    openProfile(id) {
      if (event.target.classList.contains('flew-up'))
        return false;
      this.$router.navigate(`/profile/details/?id=${ id }`);
    },
    setLoadingPage(state) {
      this.$setState({ loadingPage: state });
    },
    setPtrIsActive(value) {
      this.$setState({ ptrIsActive: value });
    },
    checkPtrIsActive() {
      if (this.ptrIsActive)
        return true;
      else
        return false;
    },
    checkIsInfinite() {
      if (this.isInfinite)
        return true;
      else
        return false;
    },
    setBoost(leaderboard, data) {
      return leaderboard.map(el => {
        if (el.id == data.own_place.id && el.place != 1 && data.promotion.boost.can_show_boost === true) {
          el.boost = true;
        } else {
          el.boost = false;
        }
        return el;
      });
    },
    fetchLeaderbordData() {
      const _this = this;
      const {skip, item} = _this.leaderboardPaginations;
      return new Promise((resolve, reject) => {
        this.$root.api(`/app/rating/points/?item=${ item }&skip=${ skip }`, {}, 'GET', function (data, status, xhr) {
          if (data.status == 'error') {
            reject(data);
          }
          if (_this.isInfinite) {
            data.leaderboard = _this.setBoost(Object.values(data.leaderboard), data);
            _this.addToLeaderboardDataUsers(Object.values(data.leaderboard), data);
            resolve();
            return false;
          }
          function sortByOrder(array) {
            let result = [];
            const order = [
              2,
              1,
              3
            ];
            if (array.length != 3)
              return array;
            while (result.length != 3) {
              result.push(array.find(el => el.place == order[0]));
              order.shift();
            }
            return result;
          }
          data.leaderboard = _this.setBoost(data.leaderboard, data);
          data.prev_season_leaders = sortByOrder(data.prev_season_leaders);
          _this.setLeaderboardPaginations(data.leaderboard.length, item, data.leaderboard_total_clients);
          _this.$setState({ leaderboardData: data });
          _this.checkViewMyPosition();
          resolve(data);
        }, true);
      });
    },
    addToLeaderboardDataUsers(users) {
      this.leaderboardData.leaderboard = this.leaderboardData.leaderboard.concat(users);
      this.$setState({ leaderboardData: this.leaderboardData });
    },
    initialization() {
      const _this = this;
      _this.setLoadingPage(true);
      _this.fetchLeaderbordData().catch(error => {
        console.log(error);
        _this.$app.dialog.alert(error.message, '');
      }).finally(() => {
        setTimeout(() => {
          _this.setLoadingPage(false);
          _this.checkIsMore();
        });
      });
    },
    ptrRefresh(e, done) {
      const _this = this;
      if (this.checkIsInfinite()) {
        done();
        return false;
      }
      _this.setPtrIsActive(true);
      _this.setLeaderboardPaginations();
      setTimeout(() => {
        _this.fetchLeaderbordData().catch(data => {
          _this.$app.dialog.alert(data.message, 'Ошибка');
        }).finally(() => {
          _this.checkIsMore();
          _this.setPtrIsActive(false);
          done();
        });
      }, 400);
    },
    sleep(ms) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve();
        }, ms);
      });
    },
    loadMore() {
      const _this = this;
      const {item, total} = _this.leaderboardPaginations;
      _this.checkViewMarginBottom();
      if (_this.checkPtrIsActive())
        return false;
      if (!_this.allowInfinite || !_this.isMore)
        return false;
      _this.$setState({
        allowInfinite: false,
        isInfinite: true
      });
      _this.setLeaderboardPaginations(this.leaderboardData.leaderboard.length, item, total);
      _this.sleep(700).then(() => {
        _this.fetchLeaderbordData().catch(data => {
          _this.$app.dialog.alert(data.message, 'Ошибка');
        }).finally(() => {
          _this.$setState({
            allowInfinite: true,
            isInfinite: false
          });
          _this.checkIsMore();
          _this.checkViewMyPosition();
          _this.checkViewMarginBottom();
        });
      });
    },
    checkViewMarginBottom() {
      if (this.viewMe) {
        this.$setState({ longPadding: false });
      } else {
        this.$setState({ longPadding: true });
      }
    },
    checkIsMore() {
      if (this.leaderboardPaginations.total <= this.leaderboardData.leaderboard.length) {
        this.$setState({ isMore: false });
      } else {
        this.$setState({ isMore: true });
      }
    },
    setLeaderboardPaginations(skip = 0, item = 20, total = 20) {
      this.$setState({
        leaderboardPaginations: {
          skip,
          item,
          total
        }
      });
    },
    handlerPageScroll(e) {
      const scrollTop = e.target.scrollTop;
      this.checkViewMyPosition();
    },
    checkViewMyPosition() {
      const myId = this.leaderboardData.own_place.id;
      const myIdx = this.leaderboardData.leaderboard.find(el => el.id == myId);
      if (this.$el.find('.my-position').length == 0) {
        return false;
      }
      const myPositionHTML = this.$el.find('.my-position')[0];
      if (typeof myIdx === 'undefined' && typeof myPositionHTML !== 'undefined') {
        myPositionHTML.classList.remove('fade-out--x3');
        myPositionHTML.classList.add('fade-in');
        return false;
      }
      const elem = this.$el.find(`#id-${ myId }`)[0];
      if (typeof elem === 'undefined')
        return false;
      const statusViewMe = this.isElementInViewport(elem);
      if (!statusViewMe && !this.viewMe)
        return false;
      if (statusViewMe && this.viewMe)
        return false;
      this.$setState({ viewMe: statusViewMe });
      if (statusViewMe) {
        myPositionHTML.classList.add('fade-out--x3');
        myPositionHTML.classList.remove('fade-in');
      } else {
        myPositionHTML.classList.remove('fade-out--x3');
        myPositionHTML.classList.add('fade-in');
      }
      ;
    },
    addHandlerScrollToPage() {
      this.$el.find(`.page-content`)[0].addEventListener('scroll', this.handlerPageScroll, false);
    },
    isElementInViewport(el) {
      var rect = el.getBoundingClientRect();
      return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
    },
    boost() {
      return new Promise((resolve, reject) => {
        this.$root.api(`/app/rating/boost`, {}, 'POST', function (data, status, xhr) {
          if (data.status == 'error') {
            reject(data);
          }
          resolve(data);
        }, true);
      });
    },
    flewUp() {
      const _this = this;
      const alert = _this.$app.dialog.create({
        title: 'Хотите подняться в рейтинге на 10 мест?',
        text: `С баланса будет списано ${ _this.leaderboardData.promotion.boost.price } 💎`,
        destroyOnClose: true,
        buttons: [
          { text: 'Отмена' },
          {
            text: 'Хочу!',
            bold: true,
            onClick: function (dialog, e) {
              try {
                _this.$app.preloader.show();
                _this.boost().then(() => {
                  _this.setLeaderboardPaginations(0, _this.leaderboardData.leaderboard.length, _this.leaderboardPaginations.total);
                  _this.fetchLeaderbordData();
                }).catch(error => {
                  _this.$app.dialog.alert(error.message, '');
                }).finally(() => {
                  _this.$app.preloader.hide();
                });
              } catch (e) {
                console.log(e);
              }
            }
          }
        ]
      });
      alert.open();
    },
    setEventLeaderbordLink() {
      const _this = this;
      document.querySelector('#leaderboard-link').addEventListener('click', () => {
        const page = _this.$el.find('.page-content')[0];
        page.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      });
    },
    load() {
      const _this = this;
      if (_this.leaderboardData === null) {
        _this.initialization();
        _this.addHandlerScrollToPage();
        _this.setEventLeaderbordLink();
      }
    },
    updateNavbarAfterHeight: function (value) {
      setTimeout(() => {
        document.documentElement.style.setProperty('--navbar-after-height', value);
      }, 100);
    }
  },
  on: {
    pageBeforeIn: function (event, page) {
      this.updateNavbarAfterHeight('1px');
    },
    pageInit: function () {
      const _this = this;
      if (_this.$route.query.noload) {
        _this.$root.removeNoLoadFromUrl(_this.$router);
      } else {
        _this.load();
      }
    }
  },
  id: '1cc82f8f0b',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page leaderboard-page">\n    <!-- Navbar -->\n    <div class="navbar navbar-transparent">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner">\n        <div class="left"></div>\n        <div class="title">\n          ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.loading, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n          ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.leaderboardData, {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n            ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.leaderboardData, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n              ';
              r += Template7Helpers.with.call(ctx_3, ctx_3.leaderboardData, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                <div class="season_info__wrapper fade-in">\n                  <span class="season-number">';
                  r += c(ctx_4.info.title, ctx_4);
                  r += '</span>\n                  <span class="season-description">';
                  r += c(ctx_4.info.subtitle, ctx_4);
                  r += '</span>\n                </div>\n              ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n            ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n          ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </div>\n        <div class="right"></div>\n      </div>\n    </div>\n    <!-- /Navbar -->\n    <div class=\'page-content ptr-content infinite-scroll-content ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.longPadding == true', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'long-padding';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\' data-ptr-mousewheel="true" @ptr:refresh="ptrRefresh" @infinite="loadMore">\n      <div class="ptr-preloader">\n        <div class="preloader"></div>\n        <div class="ptr-arrow"></div>\n      </div>\n      <!-- Last season winners -->\n      ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.loadingPage, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n        <div class="block block-strong text-align-center">\n          <div class="preloader"></div>\n        </div>\n      ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.leaderboardData, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += Template7Helpers.if.call(ctx_3, ctx_3.isMore, {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n        ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.leaderboardData, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n          ';
              r += Template7Helpers.with.call(ctx_3, ctx_3.leaderboardData, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n              ';
                  r += Template7Helpers.js_if.call(ctx_4, 'this.prev_season_leaders.length > 0', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                <div class="season-winners__wrapper">\n                  <div class="block-header">Победители прошлого сезона</div>\n                  <div class="block winners-row">\n                    ';
                      r += Template7Helpers.each.call(ctx_5, ctx_5.prev_season_leaders, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                      <div class="winner winner-';
                          r += c(ctx_6.place, ctx_6);
                          r += '">\n                        <div class="avatar__wrapper">\n                          <a data-force="true" href="/profile/details/?id=';
                          r += c(ctx_6.id, ctx_6);
                          r += '">\n                            <img src="';
                          r += c(ctx_6.avatar.url, ctx_6);
                          r += '" alt="">\n                          </a>\n                          <div class="medal medal-';
                          r += c(ctx_6.place, ctx_6);
                          r += '"></div>\n                        </div>\n                        <div class="name__wraper">\n                          <span class="name">';
                          r += c(ctx_6.name, ctx_6);
                          r += '</span>\n                        </div>\n                        <div class="scores__wrapper">\n                          <span class="scores">';
                          r += c(ctx_6.season_exp, ctx_6);
                          r += '</span>\n                        </div>\n                      </div>\n                    ';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                  </div>\n                </div>\n              ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n\n              ';
                  r += Template7Helpers.js_if.call(ctx_4, 'this.leaderboard.length > 0', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                <div class="player_list__wrapper">\n                  <div class="block-header">Лидерборд текущего сезона</div>\n                  <div class="block no-padding-horizontal">\n                    <div class="list">\n                      <ul>\n                        ';
                      r += Template7Helpers.each.call(ctx_5, ctx_5.leaderboard, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                        <li id="id-';
                          r += c(ctx_6.id, ctx_6);
                          r += '">\n                          <a href="#" @click="openProfile(';
                          r += c(ctx_6.id, ctx_6);
                          r += ')" class="player">\n                            <div class="data__wrapper">\n                              <span class="place">';
                          r += c(ctx_6.place, ctx_6);
                          r += '</span>\n                              <img class="avatar" src="';
                          r += c(ctx_6.avatar.url, ctx_6);
                          r += '" alt="">\n                              ';
                          r += Template7Helpers.js_if.call(ctx_6, 'this.place == 1 || this.place == 2 || this.place == 3', {
                            hash: {},
                            data: data_6 || {},
                            fn: function (ctx_7, data_7) {
                              var r = '';
                              r += '\n                              <div class="board place-';
                              r += c(ctx_7.place, ctx_7);
                              r += '"></div>\n                              ';
                              return r;
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '\n                              <span class="name">';
                          r += c(ctx_6.name, ctx_6);
                          r += '</span>\n                            </div>\n                            <div class="action__wrapper">\n                              ';
                          r += Template7Helpers.js_if.call(ctx_6, 'this.boost == true', {
                            hash: {},
                            data: data_6 || {},
                            fn: function (ctx_7, data_7) {
                              var r = '';
                              r += '\n                              <i class=\'flew-up ';
                              r += Template7Helpers.js_if.call(ctx_7, 'this.availableBoost == false', {
                                hash: {},
                                data: data_7 || {},
                                fn: function (ctx_8, data_8) {
                                  var r = '';
                                  r += 'disable';
                                  return r;
                                },
                                inverse: function empty() {
                                  return '';
                                },
                                root: root,
                                parents: [
                                  ctx_6,
                                  ctx_5,
                                  ctx_4,
                                  ctx_3,
                                  ctx_2,
                                  ctx_1
                                ]
                              });
                              r += '\' @click="flewUp"></i>\n                              ';
                              return r;
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '\n                              <span class="season-exp">';
                          r += c(ctx_6.season_exp, ctx_6);
                          r += '</span>\n                            </div>\n                          </a>\n                        </li>\n                        ';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                      </ul>\n                    </div>\n                  </div>\n                </div>\n\n                ';
                      r += Template7Helpers.if.call(ctx_5, ctx_5.isMore, {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                  <div class="preloader infinite-scroll-preloader"></div>\n                ';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n              ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n\n              ';
                  r += Template7Helpers.js_if.call(ctx_4, 'this.leaderboard.length == 0 && this.prev_season_leaders.length > 0', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                <div class="no-data half">\n                  <div class="image-no-users"></div>\n                  <div class="text">\n                    <span>Рассчитываем места</span>\n                    <span>Рейтинг нового сезона появится позже</span>\n                  </div>\n                </div>\n              ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n\n              ';
                  r += Template7Helpers.js_if.call(ctx_4, 'this.prev_season_leaders.length == 0 && this.leaderboard.length == 0', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n                <div class="no-data">\n                  <div class="image-no-leaderboard"></div>\n                  <div class="text">\n                    <span>Лидерборд пуст</span>\n                    <span>Победителей появятся позже</span>\n                  </div>\n                </div>\n              ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n          ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n        ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '\n        ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n      ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n      <!-- /Player list -->\n    </div>\n\n    <!-- My position -->\n    ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.loading, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n    ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.leaderboardData, {
            hash: {},
            data: data_2 || {},
            fn: function empty() {
              return '';
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n      ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.leaderboardData, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '\n        ';
              r += Template7Helpers.with.call(ctx_3, ctx_3.leaderboardData, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n          ';
                  r += Template7Helpers.js_if.call(ctx_4, 'this.own_place.place && this.promotion.boost.can_show_boost', {
                    hash: {},
                    data: data_4 || {},
                    fn: function (ctx_5, data_5) {
                      var r = '';
                      r += '\n            <div class=\'list my-position no-margin-vertical\'>\n              <ul>\n                <li>\n                  <a href="#" @click="scrollToMe(';
                      r += c(ctx_5.own_place.id, ctx_5);
                      r += ')" class="player">\n                    <div class="data__wrapper">\n                      <span class="place">';
                      r += c(ctx_5.own_place.place, ctx_5);
                      r += '</span>\n                      <img class="avatar" src="';
                      r += c(ctx_5.own_place.avatar.url, ctx_5);
                      r += '" alt="">\n                      <span class="name">';
                      r += c(ctx_5.own_place.name, ctx_5);
                      r += '</span>\n                    </div>\n                    <div class="action__wrapper">\n                      ';
                      r += Template7Helpers.js_if.call(ctx_5, 'this.own_place.place != 1', {
                        hash: {},
                        data: data_5 || {},
                        fn: function (ctx_6, data_6) {
                          var r = '';
                          r += '\n                        <i class=\'flew-up ';
                          r += Template7Helpers.js_if.call(ctx_6, 'this.promotion.boost.available == false', {
                            hash: {},
                            data: data_6 || {},
                            fn: function (ctx_7, data_7) {
                              var r = '';
                              r += 'disable';
                              return r;
                            },
                            inverse: function empty() {
                              return '';
                            },
                            root: root,
                            parents: [
                              ctx_5,
                              ctx_4,
                              ctx_3,
                              ctx_2,
                              ctx_1
                            ]
                          });
                          r += '\' @click="flewUp"></i>\n                      ';
                          return r;
                        },
                        inverse: function empty() {
                          return '';
                        },
                        root: root,
                        parents: [
                          ctx_4,
                          ctx_3,
                          ctx_2,
                          ctx_1
                        ]
                      });
                      r += '\n                      <span class="season-exp">';
                      r += c(ctx_5.own_place.season_exp, ctx_5);
                      r += '</span>\n                    </div>\n                  </a>\n                </li>\n              </ul>\n            </div>\n          ';
                      return r;
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [
                      ctx_3,
                      ctx_2,
                      ctx_1
                    ]
                  });
                  r += '\n        ';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [
                  ctx_2,
                  ctx_1
                ]
              });
              r += '\n      ';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '\n      <!-- /My position -->\n    ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n  </div>\n';
      return r;
    }(this);
  },
  style: `
  .long-padding {
    padding-bottom: calc(var(--f7-page-toolbar-bottom-offset, 0px) + var(--f7-safe-area-bottom) + var(--f7-page-content-extra-padding-bottom, 0px) + 45px);
  }
  #view-leaderboard .navbar .navbar-inner .title .season_info__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: inherit;
    color: var(--f7-navbar-text-color);
    font-style: normal;
    font-weight: normal;
  }
  #view-leaderboard .navbar .navbar-inner .season_info__wrapper .season-number {
    font-size: 15px;
    line-height: 15px;
    letter-spacing: -0.24px;
  }
  #view-leaderboard .navbar .navbar-inner .season_info__wrapper .season-description {
    font-size: 11px;
    line-height: 11px;
    opacity: 0.6;
  }
  #view-leaderboard .navbar .navbar-inner .season_info__wrapper .season-number + .season-description {
    margin-top: 4.5px;
  }
  #view-leaderboard .no-data {
    display: flex;
    height: inherit;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  #view-leaderboard .no-data.half {
    height: calc(100vh - 346px) !important;
  }
  #view-leaderboard .no-data .image-no-users {
    width: 100px;
    height: 100px;
    background-repeat: no-repeat;
    background-image: url("data:image/svg+xml,%3Csvg width='101' height='100' viewBox='0 0 101 100' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_8754_54454)'%3E%3Cpath d='M90.9297 0H79.0605C77.1209 0.0671875 77.1225 2.86328 79.0605 2.92969H90.9297C90.9834 2.92969 91.0273 2.97344 91.0273 3.02734V35.4492C91.0273 35.5031 90.9834 35.5469 90.9297 35.5469H17.0908V2.92969H80.2396C82.1793 2.8625 82.1777 0.0664062 80.2396 0H10.0703C8.40098 0 7.04297 1.35801 7.04297 3.02734V35.4492C7.04297 37.1186 8.40098 38.4766 10.0703 38.4766H90.9297C92.599 38.4766 93.957 37.1186 93.957 35.4492V3.02734C93.957 1.35801 92.599 0 90.9297 0ZM9.97266 35.4492V3.02734C9.97266 2.97344 10.0166 2.92969 10.0703 2.92969H14.1611V35.5469H10.0703C10.0166 35.5469 9.97266 35.5031 9.97266 35.4492Z' fill='%23CFD6DB'/%3E%3Cpath d='M80.2576 43.6602H38.1953C36.2557 43.7273 36.2572 46.5234 38.1953 46.5898H79.886V67.2041H27.8719V46.5898H39.2209C41.1606 46.5227 41.159 43.7266 39.2209 43.6602H20.3819C18.9713 43.6602 17.8239 44.8076 17.8239 46.2182V67.576C17.8239 68.9865 18.9713 70.134 20.3819 70.134H80.2576C81.6682 70.134 82.8156 68.9865 82.8156 67.576V46.2184C82.8156 44.8078 81.6682 43.6602 80.2576 43.6602ZM20.7535 46.5898H24.942V67.2041H20.7535V46.5898Z' fill='%23CFD6DB'/%3E%3Cpath d='M42.2744 20.6545C43.5029 19.4461 43.9328 17.6754 43.3963 16.0332C42.8633 14.4017 41.4828 13.2345 39.7938 12.9869L37.6633 12.6746C37.0248 12.581 36.4723 12.1746 36.1854 11.5879L35.2326 9.64001C33.6405 6.30701 28.8006 6.30798 27.2094 9.64001L26.2567 11.5879C25.9696 12.1746 25.417 12.5808 24.7787 12.6744L22.6485 12.9869C20.9592 13.2345 19.5785 14.4019 19.0457 16.0332C18.5094 17.6754 18.9393 19.4461 20.1676 20.6543L21.7094 22.1705C22.1762 22.6297 22.3889 23.2922 22.2783 23.9426L21.9145 26.0834C21.2602 29.7047 25.1619 32.5763 28.4069 30.8205L30.3123 29.8097C30.8815 29.508 31.5612 29.5078 32.1303 29.8097L34.0358 30.8205C34.6965 31.1709 35.4123 31.3441 36.1248 31.3441C37.0403 31.3441 37.95 31.0584 38.7289 30.4953C40.1293 29.4834 40.8188 27.7929 40.5281 26.0834L40.1643 23.9426C40.0539 23.292 40.2664 22.6297 40.7336 22.1705L42.2744 20.6545ZM40.2199 18.5658L38.6785 20.082C37.5289 21.2125 37.0045 22.8394 37.2754 24.434L37.6393 26.5748C37.7428 27.1845 37.5084 27.7627 37.0123 28.1211C36.7813 28.2881 36.1625 28.6332 35.4078 28.2328L33.5024 27.222C32.0737 26.464 30.3674 26.464 28.9387 27.222L27.0332 28.2328C26.2785 28.6332 25.6598 28.2879 25.4287 28.1211C24.9326 27.7625 24.6983 27.1844 24.8018 26.5748L25.1656 24.434C25.4367 22.8396 24.9123 21.2127 23.7629 20.0822L22.2211 18.566C21.2979 17.7164 21.8199 16.0324 23.0725 15.8859L25.2028 15.5734C26.7983 15.3396 28.1758 14.3308 28.8875 12.8754L29.8403 10.9275C30.3608 9.77712 32.0795 9.77751 32.6 10.9275L33.5528 12.8754C34.2649 14.331 35.6424 15.3396 37.2375 15.5734L39.368 15.8857C40.6215 16.0322 41.1432 17.7168 40.2199 18.5658Z' fill='%23CFD6DB'/%3E%3Cpath d='M81.9249 24.291H48.3516C46.412 24.3582 46.4135 27.1543 48.3516 27.2207H81.9249C83.8643 27.1535 83.863 24.3576 81.9249 24.291Z' fill='%23CFD6DB'/%3E%3Cpath d='M81.9249 17.7734H48.3516C46.412 17.8406 46.4135 20.6367 48.3516 20.7031H81.9249C83.8643 20.6359 83.863 17.8398 81.9249 17.7734Z' fill='%23CFD6DB'/%3E%3Cpath d='M48.3516 14.1855H58.479C60.4186 14.1184 60.417 11.3223 58.479 11.2559H48.3516C46.412 11.323 46.4135 14.1189 48.3516 14.1855Z' fill='%23CFD6DB'/%3E%3Cpath d='M31.9167 59.7168C31.9167 60.5258 32.5724 61.1816 33.3816 61.1816H68.4906C70.4302 61.1145 70.4287 58.3184 68.4906 58.252H33.3816C32.5724 58.252 31.9167 58.9078 31.9167 59.7168Z' fill='%23CFD6DB'/%3E%3Cpath d='M50.5 51.7363H33.3816C31.442 51.8035 31.4436 54.5996 33.3816 54.666H50.5C52.4396 54.5988 52.4381 51.8027 50.5 51.7363Z' fill='%23CFD6DB'/%3E%3Cpath d='M80.2576 73.5273H20.3819C18.9713 73.5273 17.8239 74.6748 17.8239 76.0854V97.4432C17.8239 98.8537 18.9713 100.001 20.3819 100.001H58.528C60.4676 99.934 60.466 97.1379 58.528 97.0715H27.8719V76.457H79.886V97.0713H57.3789C55.4393 97.1385 55.4408 99.9346 57.3789 100.001H80.2578C81.6684 100.001 82.8158 98.8535 82.8158 97.443V76.0852C82.8156 74.6748 81.6682 73.5273 80.2576 73.5273ZM24.9422 97.0713H20.7537V76.457H24.9422V97.0713Z' fill='%23CFD6DB'/%3E%3Cpath d='M33.3816 91.0469H68.4906C70.4302 90.9797 70.4287 88.1836 68.4906 88.1172H33.3816C31.4419 88.1842 31.4433 90.9803 33.3816 91.0469Z' fill='%23CFD6DB'/%3E%3Cpath d='M33.3816 84.5293H50.5C52.4396 84.4621 52.438 81.666 50.5 81.5996H33.3816C31.4419 81.6668 31.4433 84.4629 33.3816 84.5293Z' fill='%23CFD6DB'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_8754_54454'%3E%3Crect width='100' height='100' fill='white' transform='translate(0.5)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
  }
  #view-leaderboard .image-no-leaderboard {
    width: 213px;
    height: 130px;
    background-repeat: no-repeat;
    background-image: url("data:image/svg+xml,%3Csvg width='213' height='130' viewBox='0 0 213 130' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0_8754_54239)'%3E%3Cg clip-path='url(%23clip1_8754_54239)'%3E%3Cpath d='M143.875 50.7269C143.875 71.3143 127.02 88.0242 106.203 88.0242C85.3863 88.0242 68.5316 71.3143 68.5316 50.7269C68.5316 30.1396 85.3863 13.4297 106.203 13.4297C127.02 13.4297 143.875 30.1396 143.875 50.7269Z' stroke='%23CFD6DB' stroke-width='2.5'/%3E%3Cpath d='M106.203 76.9873C91.5616 76.9873 79.67 65.1897 79.67 50.7215C79.67 36.2534 91.5614 24.459 106.203 24.459C120.844 24.459 132.736 36.2566 132.736 50.7248C132.736 65.1929 120.845 76.9873 106.203 76.9873Z' stroke='%23CFD6DB' stroke-width='2.5'/%3E%3Cpath d='M77.4638 75.3457L63.0361 100.528L84.1893 94.1904L91.4676 113.366L106.203 88.058' stroke='%23CFD6DB' stroke-width='2.5'/%3E%3Cpath d='M134.943 74.166L149.371 99.3479L128.218 93.0107L120.939 112.186L106.203 86.8784' stroke='%23CFD6DB' stroke-width='2.5'/%3E%3C/g%3E%3Cpath d='M106.032 39.8709C108.573 39.8709 110.1 41.2281 110.1 43.5174C110.1 47.6752 102.688 48.8212 102.688 53.8673C102.688 55.2245 103.575 56.7077 105.397 56.7077C108.193 56.7077 107.855 54.6295 108.872 53.1435C110.226 51.1517 116.539 49.031 116.539 43.516C116.539 37.5377 111.203 35.0332 105.78 35.0332C100.615 35.0332 95.868 38.7235 95.868 42.8813C95.868 44.5771 97.14 45.4681 98.6227 45.4681C102.729 45.4695 100.612 39.8709 106.032 39.8709Z' fill='%23CFD6DB'/%3E%3Cpath d='M109.04 62.9446C109.04 61.035 107.473 59.4668 105.567 59.4668C103.661 59.4668 102.093 61.0378 102.093 62.9446C102.093 64.8542 103.661 66.4225 105.567 66.4225C107.473 66.4225 109.04 64.8542 109.04 62.9446Z' fill='%23CFD6DB'/%3E%3Cg clip-path='url(%23clip2_8754_54239)'%3E%3Cpath d='M54.9433 83.1263C54.9433 95.2595 45.0086 105.116 32.7281 105.116C20.4475 105.116 10.5128 95.2595 10.5128 83.1263C10.5128 70.9932 20.4475 61.1367 32.7281 61.1367C45.0086 61.1367 54.9433 70.9932 54.9433 83.1263Z' stroke='%23CFD6DB' stroke-width='2.5'/%3E%3Cpath d='M32.728 98.463C24.1705 98.463 17.228 91.5681 17.228 83.124C17.228 74.6801 24.1703 67.7871 32.728 67.7871C41.2855 67.7871 48.228 74.6819 48.228 83.126C48.228 91.5699 41.2857 98.463 32.728 98.463Z' stroke='%23CFD6DB' stroke-width='2.5'/%3E%3Cpath d='M15.4015 97.9688L6.70325 113.151L19.4562 109.33L23.8442 120.891L32.7283 105.633' stroke='%23CFD6DB' stroke-width='2.5'/%3E%3Cpath d='M50.055 97.2578L58.7533 112.44L46.0003 108.619L41.6124 120.18L32.7283 104.922' stroke='%23CFD6DB' stroke-width='2.5'/%3E%3C/g%3E%3Cpath d='M32.6495 78.1948C33.8072 78.1948 34.5027 78.8116 34.5027 79.852C34.5027 81.7417 31.1255 82.2625 31.1255 84.5559C31.1255 85.1727 31.5298 85.8468 32.36 85.8468C33.6338 85.8468 33.4797 84.9023 33.9432 84.2269C34.5601 83.3217 37.4364 82.3578 37.4364 79.8514C37.4364 77.1344 35.0055 75.9961 32.5347 75.9961C30.1811 75.9961 28.0184 77.6733 28.0184 79.5629C28.0184 80.3336 28.5979 80.7386 29.2735 80.7386C31.1443 80.7392 30.1799 78.1948 32.6495 78.1948Z' fill='%23CFD6DB'/%3E%3Cpath d='M34.0191 88.6822C34.0191 87.8143 33.3049 87.1016 32.4366 87.1016C31.5682 87.1016 30.854 87.8156 30.854 88.6822C30.854 89.5501 31.5682 90.2628 32.4366 90.2628C33.3049 90.2628 34.0191 89.5501 34.0191 88.6822Z' fill='%23CFD6DB'/%3E%3Cg clip-path='url(%23clip3_8754_54239)'%3E%3Cpath d='M201.893 83.1263C201.893 95.2595 191.959 105.116 179.678 105.116C167.398 105.116 157.463 95.2595 157.463 83.1263C157.463 70.9932 167.398 61.1367 179.678 61.1367C191.959 61.1367 201.893 70.9932 201.893 83.1263Z' stroke='%23CFD6DB' stroke-width='2.5'/%3E%3Cpath d='M179.678 98.463C171.121 98.463 164.178 91.5681 164.178 83.124C164.178 74.6801 171.121 67.7871 179.678 67.7871C188.236 67.7871 195.178 74.6819 195.178 83.126C195.178 91.5699 188.236 98.463 179.678 98.463Z' stroke='%23CFD6DB' stroke-width='2.5'/%3E%3Cpath d='M162.352 97.9688L153.653 113.151L166.406 109.33L170.794 120.891L179.678 105.633' stroke='%23CFD6DB' stroke-width='2.5'/%3E%3Cpath d='M197.005 97.2578L205.703 112.44L192.951 108.619L188.563 120.18L179.678 104.922' stroke='%23CFD6DB' stroke-width='2.5'/%3E%3C/g%3E%3Cpath d='M179.6 78.1948C180.757 78.1948 181.453 78.8116 181.453 79.852C181.453 81.7417 178.076 82.2625 178.076 84.5559C178.076 85.1727 178.48 85.8468 179.31 85.8468C180.584 85.8468 180.43 84.9023 180.893 84.2269C181.51 83.3217 184.387 82.3578 184.387 79.8514C184.387 77.1344 181.956 75.9961 179.485 75.9961C177.131 75.9961 174.969 77.6733 174.969 79.5629C174.969 80.3336 175.548 80.7386 176.224 80.7386C178.094 80.7392 177.13 78.1948 179.6 78.1948Z' fill='%23CFD6DB'/%3E%3Cpath d='M180.969 88.6822C180.969 87.8143 180.255 87.1016 179.387 87.1016C178.518 87.1016 177.804 87.8156 177.804 88.6822C177.804 89.5501 178.518 90.2628 179.387 90.2628C180.255 90.2628 180.969 89.5501 180.969 88.6822Z' fill='%23CFD6DB'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0_8754_54239'%3E%3Crect width='212' height='130' fill='white' transform='translate(0.203125)'/%3E%3C/clipPath%3E%3CclipPath id='clip1_8754_54239'%3E%3Crect width='106.666' height='105.641' fill='white' transform='translate(52.8698 12.1797)'/%3E%3C/clipPath%3E%3CclipPath id='clip2_8754_54239'%3E%3Crect width='64.3078' height='63.6894' fill='white' transform='translate(0.574097 59.8867)'/%3E%3C/clipPath%3E%3CclipPath id='clip3_8754_54239'%3E%3Crect width='64.3078' height='63.6894' fill='white' transform='translate(147.524 59.8867)'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
  }
  #view-leaderboard .no-data .image-no-users + .text {
    margin-top: 14px;
  }
  #view-leaderboard .no-data .image-no-leaderboard + .text {
    margin-top: 14px;
  }
  #view-leaderboard .no-data .text {
    display: flex;
    flex-direction: column;
  }
  #view-leaderboard .no-data .text span:nth-child(1) {
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 24px;
    align-items: center;
    text-align: center;
    letter-spacing: -0.41px;
    color: #818E95;
  }
  #view-leaderboard .no-data .text span:nth-child(2) {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 16px;
    align-items: center;
    text-align: center;
    letter-spacing: -0.41px;
    color: #ACB4BE;
  }
  #view-leaderboard .no-data .text span:nth-child(1) + span:nth-child(2) {
    margin-top: 7px;
  }
  .leaderboard-page .page-content .block-header {
    text-transform: uppercase;
    font-size: 12px;
    line-height: 18px;
    color: #818E95;
    margin-top: 24px;
    margin-bottom: 8px;
    padding-left: 16px;
    padding-right: 16px;
  }
  .leaderboard-page .page-content .season-winners__wrapper .block.winners-row {
    width: 100%;
    height: 190px;
    background-color: #FFF;
    display: flex;
    gap: 8px;
    justify-content: center;
    padding-top: 16px;
    padding-bottom: 16px;
  }
  .leaderboard-page .page-content .season-winners__wrapper .block.winners-row .winner {
    width: 100%;
    height: 100%;
    flex: 1 0 90px;
    max-width: 100px;
    display: flex;
    flex-direction: column;
  }
  .leaderboard-page .page-content .season-winners__wrapper .block.winners-row .winner .avatar__wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 90px;
    position: relative;
  }
  .leaderboard-page .page-content .season-winners__wrapper .block.winners-row .winner-1 img {
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }
  .leaderboard-page .page-content .season-winners__wrapper .block.winners-row .winner-2 img {
    width: 56px;
    height: 56px;
    border-radius: 50%;
  }
  .leaderboard-page .page-content .season-winners__wrapper .block.winners-row .winner-3 img {
    width: 48px;
    height: 48px;
    border-radius: 50%;
  }
  .leaderboard-page .page-content .season-winners__wrapper .block.winners-row .winner .avatar__wrapper .medal {
    position: absolute;
    width: 48px;
    height: 48px;
    bottom: -25px;
  }
  .leaderboard-page .page-content .season-winners__wrapper .block.winners-row .winner .name__wraper {
    margin-top: 30px;
    text-align: center;
  }
  .leaderboard-page .page-content .season-winners__wrapper .block.winners-row .winner .name__wraper .name {
    font-weight: 500;
    font-size: 15px;
    line-height: 18px;
    color: #445058;
  }
  .leaderboard-page .page-content .season-winners__wrapper .block.winners-row .winner .scores__wrapper {
    display: flex;
    justify-content: center;
    margin-top: 4px;
  }
  .leaderboard-page .page-content .season-winners__wrapper .block.winners-row .winner .scores__wrapper .scores {
    font-size: 13px;
    line-height: 16px;
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    padding: 2px 10px;
    color: #445058;
  }
  .leaderboard-page .page-content .player_list__wrapper .block {
    width: 100%;
    background: #FFF;
  }
  /* .leaderboard-page .page-content .player_list__wrapper .block .list li:active {
    background-color: var(--f7-list-link-pressed-bg-color);
  }
  .leaderboard-page .page-content .player_list__wrapper .block .list li:active .avatar {
    border-color: var(--f7-list-link-pressed-bg-color);
  } */
  .leaderboard-page .page-content .player_list__wrapper .block .list li {
    height: 64px;
    display: flex;
    align-items: center;
  }
  .leaderboard-page .page-content .player_list__wrapper .block .list li::after {
    content: '';
    position: absolute;
    background-color: var(--f7-list-item-border-color);
    display: block;
    z-index: 15;
    top: auto;
    right: auto;
    bottom: 0;
    left: 52px;
    height: 1px;
    width: calc(100% - 54px);
    transform-origin: 50% 100%;
    transform: scaleY(calc(1 / 1));
    transform: scaleY(calc(1 / var(--f7-device-pixel-ratio)));
  }
  .leaderboard-page .player {
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 16px);
    padding-right: 16px;
  }
  .leaderboard-page .player .data__wrapper {
    display: flex;
    align-items: center;
    position: relative;
    padding-left: 16px;
  }
  .leaderboard-page .player .place {
    font-weight: 600;
    font-size: 17px;
    line-height: 20px;
    color: #445058;
    position: relative;
    z-index: 1;
    width: 28px;
  }
  .leaderboard-page .player .avatar {
    width: 36px;
    height: 36px;
    border: 7px solid #FFF;
    border-radius: 50%;
    position: relative;
    z-index: 1;
  }
  .leaderboard-page .player .board {
    width: 84px;
    height: 36px;
    position: absolute;
    left: 0;
  }
  .leaderboard-page .player .board.place-1 {
    background: #FDDB53;
  }
  .leaderboard-page .player .board.place-2 {
    background: #CFE2F3;
  }
  .leaderboard-page .player .board.place-3 {
    background: #F2C08E;
  }
  .leaderboard-page .player .name {
    margin-left: 8px;
    font-size: 17px;
    line-height: 20px;
    color: #445058;
  }
  .leaderboard-page .medal-1 {
    height: 48px;
    width: 48px;
    background-repeat: no-repeat;
    background-image: url("data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0)'%3E%3Cpath d='M14.1958 20.752L3.71338 40.5012L13.2323 39.6218L17.8395 47.9987L28.3219 28.2495L14.1958 20.752Z' fill='%23E95454'/%3E%3Cpath d='M15.3967 42.2492C15.6908 41.6174 15.3832 40.8626 14.7679 40.5354L14.1646 40.2142C13.5613 39.8706 13.3317 39.1067 13.6604 38.4884C13.9935 37.8596 14.7769 37.6195 15.4057 37.9527L17.1105 38.8576C17.6372 39.1367 18.2975 38.9341 18.5692 38.4044L18.6112 38.3234C18.9233 37.8236 18.7387 37.1633 18.2195 36.8887L13.1201 34.1829C12.4988 33.8528 12.1942 33.1009 12.4838 32.4676C12.8035 31.7938 13.6108 31.5282 14.2606 31.8733L18.9909 34.384C19.5176 34.6631 20.1779 34.4606 20.4571 33.9338L20.4841 33.8648L20.4916 33.8498C20.7932 33.2975 20.5816 32.6042 20.0248 32.3085L17.3716 30.9009C16.7503 30.5707 16.4457 29.8189 16.7398 29.1781C17.0565 28.5118 17.8668 28.2386 18.5166 28.5838L21.4475 30.14C21.9953 30.4312 22.6496 30.188 22.9332 29.6358C22.9377 29.6283 22.9377 29.6283 22.9407 29.6208C22.9452 29.6133 22.9452 29.6133 22.9482 29.6058C23.2469 29.061 23.0818 28.3827 22.5325 28.0931L19.3705 26.4153C18.7568 26.0896 18.4521 25.3378 18.7417 24.7045C19.0614 24.0307 19.8688 23.765 20.5186 24.1102L28.3192 28.2506L17.8368 47.9999L14.948 42.7489C15.1341 42.6229 15.2961 42.4668 15.3967 42.2492Z' fill='%23ED6362'/%3E%3Cpath d='M33.8043 20.752L44.2868 40.5012L34.7678 39.6218L30.1606 47.9987L19.6782 28.2495L33.8043 20.752Z' fill='%23ED6362'/%3E%3Cpath d='M32.6037 42.2477C32.3096 41.6159 32.6173 40.8611 33.2325 40.5339L33.8358 40.2127C34.4391 39.8691 34.6687 39.1052 34.3401 38.4869C34.0069 37.8581 33.2235 37.618 32.5947 37.9512L30.8899 38.8561C30.3632 39.1352 29.7029 38.9326 29.4313 38.4029L29.3892 38.3219C29.0771 37.8221 29.2617 37.1618 29.7809 36.8872L34.8818 34.1799C35.5031 33.8498 35.8077 33.0979 35.5181 32.4646C35.1985 31.7908 34.3911 31.5252 33.7413 31.8703L29.0111 34.381C28.4843 34.6601 27.824 34.4576 27.5449 33.9308L27.5179 33.8618L27.5104 33.8468C27.2087 33.2945 27.4203 32.6012 27.9771 32.3055L30.6303 30.8979C31.2516 30.5677 31.5563 29.8159 31.2621 29.1751C30.9455 28.5088 30.1351 28.2356 29.4853 28.5808L26.5514 30.14C26.0037 30.4312 25.3493 30.188 25.0657 29.6358C25.0612 29.6283 25.0612 29.6283 25.0582 29.6208C25.0537 29.6133 25.0537 29.6133 25.0507 29.6058C24.7521 29.061 24.9171 28.3827 25.4664 28.0931L28.6284 26.4153C29.2422 26.0896 29.5468 25.3378 29.2572 24.7045C28.9375 24.0307 28.1302 23.765 27.4803 24.1102L19.6797 28.2506L30.1621 47.9999L33.051 42.7489C32.8664 42.6214 32.7043 42.4653 32.6037 42.2477Z' fill='%23E95454'/%3E%3Cpath d='M24.0001 35.0294C33.6732 35.0294 41.5147 27.1878 41.5147 17.5147C41.5147 7.8416 33.6732 0 24.0001 0C14.327 0 6.48535 7.8416 6.48535 17.5147C6.48535 27.1878 14.327 35.0294 24.0001 35.0294Z' fill='%23FFCC5B'/%3E%3Cpath d='M26.3754 15.5051H15.2762C14.4133 15.5051 13.705 14.7968 13.705 13.9339L13.717 13.8258V13.8018C13.705 12.8909 14.4478 12.1465 15.3603 12.1465H23.0529C24.0718 12.1465 24.9723 11.3917 25.0323 10.3712C25.0803 9.3042 24.2294 8.40378 23.1609 8.40378H15.0121C14.1132 8.40378 13.4409 7.64892 13.4529 6.7485C13.4529 6.73649 13.4529 6.73649 13.4529 6.72449C13.4529 6.71248 13.4529 6.71248 13.4529 6.70048C13.4409 5.80156 14.1117 5.0452 15.0121 5.0452H23.5391C24.5461 5.0452 25.4465 4.29035 25.5065 3.28188C25.5545 2.20287 24.7036 1.31445 23.6351 1.31445H17.3907C11.0232 3.93918 6.53613 10.2001 6.53613 17.5145C6.53613 24.829 11.0232 31.0884 17.3922 33.7101H25.3204C26.3274 33.7101 27.2278 32.9553 27.2878 31.9468C27.3359 30.8678 26.485 29.9809 25.4165 29.9809L16.3972 29.9794C15.3332 29.9794 14.4763 29.0895 14.5334 28.012C14.5859 27.0035 15.4923 26.2456 16.5023 26.2456H19.9989C21.0044 26.2171 21.8163 25.3932 21.8163 24.3803C21.8163 23.3493 20.9774 22.5089 19.9449 22.5089H14.6444C13.7815 22.5089 13.0732 21.8021 13.0852 20.9376V20.8056C13.0252 19.9547 13.7095 19.2344 14.5604 19.2344H26.2674C27.2863 19.2344 28.1868 18.4795 28.2468 17.471C28.2948 16.3935 27.4424 15.5051 26.3754 15.5051Z' fill='%23FDBC4B'/%3E%3Cpath d='M23.9999 30.0149C17.1057 30.0149 11.4976 24.4053 11.4976 17.5126C11.4976 10.6198 17.1057 5.01172 23.9999 5.01172C30.8942 5.01172 36.5023 10.6213 36.5023 17.5141C36.5023 24.4068 30.8942 30.0149 23.9999 30.0149Z' fill='%23FFDB70'/%3E%3Cpath opacity='0.2' d='M36.5024 17.5152C36.5024 10.8641 31.2769 5.424 24.7174 5.04883H23.5528C22.7845 5.04883 22.0987 5.6251 22.0521 6.39346C22.0161 7.21584 22.6644 7.89416 23.4793 7.89416L30.3585 7.89566C31.1704 7.89566 31.8232 8.57398 31.7797 9.39637C31.7392 10.1662 31.0488 10.744 30.2775 10.744H27.6107C26.8439 10.7665 26.2241 11.3938 26.2241 12.1667C26.2241 12.953 26.8649 13.5938 27.6512 13.5938H31.6941C32.3529 13.5938 32.8917 14.1341 32.8827 14.7914V14.8904C32.9277 15.5402 32.407 16.088 31.7572 16.088H22.8295C22.0521 16.088 21.3663 16.6643 21.3198 17.4326C21.2838 18.255 21.9321 18.9333 22.747 18.9333H31.2109C31.8697 18.9333 32.4085 19.4736 32.4085 20.1309L32.3995 20.2134V20.2314C32.4085 20.9263 31.8412 21.4935 31.1464 21.4935H25.2786C24.5013 21.4935 23.8155 22.0698 23.7689 22.8472C23.7329 23.6606 24.3812 24.3479 25.1961 24.3479H31.4105C32.0963 24.3479 32.6081 24.9241 32.5991 25.61C32.5991 25.619 32.5991 25.619 32.5991 25.628C32.5991 25.637 32.5991 25.637 32.5991 25.646C32.6081 26.3318 32.0963 26.9081 31.4105 26.9081H24.908C24.1396 26.9081 23.4538 27.4843 23.4073 28.2527C23.3712 29.0766 24.0196 29.7534 24.8344 29.7534H26.5497C32.2269 28.5709 36.5024 23.533 36.5024 17.5152Z' fill='white'/%3E%3Cpath d='M23.7168 25H26.6367V10.9082H23.707L20.0645 13.4375V16.0547L23.6582 13.6133H23.7168V25Z' fill='%23EC9922'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0'%3E%3Crect width='48' height='48' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
  }
  .leaderboard-page .medal-2 {
    height: 48px;
    width: 48px;
    background-repeat: no-repeat;
    background-image: url("data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0)'%3E%3Cpath d='M14.1958 20.752L3.71338 40.5012L13.2323 39.6218L17.8395 47.9987L28.3219 28.2495L14.1958 20.752Z' fill='%235393F2'/%3E%3Cpath d='M15.3967 42.2492C15.6908 41.6174 15.3832 40.8626 14.7679 40.5354L14.1646 40.2142C13.5613 39.8706 13.3317 39.1067 13.6604 38.4884C13.9935 37.8596 14.7769 37.6195 15.4057 37.9527L17.1105 38.8576C17.6372 39.1367 18.2975 38.9341 18.5692 38.4044L18.6112 38.3234C18.9233 37.8236 18.7387 37.1633 18.2195 36.8887L13.1201 34.1829C12.4988 33.8528 12.1942 33.1009 12.4838 32.4676C12.8035 31.7938 13.6108 31.5282 14.2606 31.8733L18.9909 34.384C19.5176 34.6631 20.1779 34.4606 20.4571 33.9338L20.4841 33.8648L20.4916 33.8498C20.7932 33.2975 20.5816 32.6042 20.0248 32.3085L17.3716 30.9009C16.7503 30.5707 16.4457 29.8189 16.7398 29.1781C17.0565 28.5118 17.8668 28.2386 18.5166 28.5838L21.4475 30.14C21.9953 30.4312 22.6496 30.188 22.9332 29.6358C22.9377 29.6283 22.9377 29.6283 22.9407 29.6208C22.9452 29.6133 22.9452 29.6133 22.9482 29.6058C23.2469 29.061 23.0818 28.3827 22.5325 28.0931L19.3705 26.4153C18.7568 26.0896 18.4521 25.3378 18.7417 24.7045C19.0614 24.0307 19.8688 23.765 20.5186 24.1102L28.3192 28.2506L17.8368 47.9999L14.948 42.7489C15.1341 42.6229 15.2961 42.4668 15.3967 42.2492Z' fill='%236FA7FA'/%3E%3Cpath d='M33.8043 20.752L44.2868 40.5012L34.7678 39.6218L30.1606 47.9987L19.6782 28.2495L33.8043 20.752Z' fill='%236FA7FA'/%3E%3Cpath d='M32.6037 42.2477C32.3096 41.6159 32.6173 40.8611 33.2325 40.5339L33.8358 40.2127C34.4391 39.8691 34.6687 39.1052 34.3401 38.4869C34.0069 37.8581 33.2235 37.618 32.5947 37.9512L30.8899 38.8561C30.3632 39.1352 29.7029 38.9326 29.4313 38.4029L29.3892 38.3219C29.0771 37.8221 29.2617 37.1618 29.7809 36.8872L34.8818 34.1799C35.5031 33.8498 35.8077 33.0979 35.5181 32.4646C35.1985 31.7908 34.3911 31.5252 33.7413 31.8703L29.0111 34.381C28.4843 34.6601 27.824 34.4576 27.5449 33.9308L27.5179 33.8618L27.5104 33.8468C27.2087 33.2945 27.4203 32.6012 27.9771 32.3055L30.6303 30.8979C31.2516 30.5677 31.5563 29.8159 31.2621 29.1751C30.9455 28.5088 30.1351 28.2356 29.4853 28.5808L26.5514 30.14C26.0037 30.4312 25.3493 30.188 25.0657 29.6358C25.0612 29.6283 25.0612 29.6283 25.0582 29.6208C25.0537 29.6133 25.0537 29.6133 25.0507 29.6058C24.7521 29.061 24.9171 28.3827 25.4664 28.0931L28.6284 26.4153C29.2422 26.0896 29.5468 25.3378 29.2572 24.7045C28.9375 24.0307 28.1302 23.765 27.4803 24.1102L19.6797 28.2506L30.1621 47.9999L33.051 42.7489C32.8664 42.6214 32.7043 42.4653 32.6037 42.2477Z' fill='%235393F2'/%3E%3Cpath d='M24.0001 35.0294C33.6732 35.0294 41.5147 27.1878 41.5147 17.5147C41.5147 7.8416 33.6732 0 24.0001 0C14.327 0 6.48535 7.8416 6.48535 17.5147C6.48535 27.1878 14.327 35.0294 24.0001 35.0294Z' fill='%23C3C5C7'/%3E%3Cpath d='M26.3754 15.5051H15.2762C14.4133 15.5051 13.705 14.7968 13.705 13.9339L13.717 13.8258V13.8018C13.705 12.8909 14.4478 12.1465 15.3603 12.1465H23.0529C24.0718 12.1465 24.9723 11.3917 25.0323 10.3712C25.0803 9.3042 24.2294 8.40378 23.1609 8.40378H15.0121C14.1132 8.40378 13.4409 7.64892 13.4529 6.7485C13.4529 6.73649 13.4529 6.73649 13.4529 6.72449C13.4529 6.71248 13.4529 6.71248 13.4529 6.70048C13.4409 5.80156 14.1117 5.0452 15.0121 5.0452H23.5391C24.5461 5.0452 25.4465 4.29035 25.5065 3.28188C25.5545 2.20287 24.7036 1.31445 23.6351 1.31445H17.3907C11.0232 3.93918 6.53613 10.2001 6.53613 17.5145C6.53613 24.829 11.0232 31.0884 17.3922 33.7101H25.3204C26.3274 33.7101 27.2278 32.9553 27.2878 31.9468C27.3359 30.8678 26.485 29.9809 25.4165 29.9809L16.3972 29.9794C15.3332 29.9794 14.4763 29.0895 14.5334 28.012C14.5859 27.0035 15.4923 26.2456 16.5023 26.2456H19.9989C21.0044 26.2171 21.8163 25.3932 21.8163 24.3803C21.8163 23.3493 20.9774 22.5089 19.9449 22.5089H14.6444C13.7815 22.5089 13.0732 21.8021 13.0852 20.9376V20.8056C13.0252 19.9547 13.7095 19.2344 14.5604 19.2344H26.2674C27.2863 19.2344 28.1868 18.4795 28.2468 17.471C28.2948 16.3935 27.4424 15.5051 26.3754 15.5051Z' fill='%23B5B6B8'/%3E%3Cpath d='M23.9999 30.0149C17.1057 30.0149 11.4976 24.4053 11.4976 17.5126C11.4976 10.6198 17.1057 5.01172 23.9999 5.01172C30.8942 5.01172 36.5023 10.6213 36.5023 17.5141C36.5023 24.4068 30.8942 30.0149 23.9999 30.0149Z' fill='%23E7E7E7'/%3E%3Cpath opacity='0.2' d='M36.5024 17.5152C36.5024 10.8641 31.2769 5.424 24.7174 5.04883H23.5528C22.7845 5.04883 22.0987 5.6251 22.0521 6.39346C22.0161 7.21584 22.6644 7.89416 23.4793 7.89416L30.3585 7.89566C31.1704 7.89566 31.8232 8.57398 31.7797 9.39637C31.7392 10.1662 31.0488 10.744 30.2775 10.744H27.6107C26.8439 10.7665 26.2241 11.3938 26.2241 12.1667C26.2241 12.953 26.8649 13.5938 27.6512 13.5938H31.6941C32.3529 13.5938 32.8917 14.1341 32.8827 14.7914V14.8904C32.9277 15.5402 32.407 16.088 31.7572 16.088H22.8295C22.0521 16.088 21.3663 16.6643 21.3198 17.4326C21.2838 18.255 21.9321 18.9333 22.747 18.9333H31.2109C31.8697 18.9333 32.4085 19.4736 32.4085 20.1309L32.3995 20.2134V20.2314C32.4085 20.9263 31.8412 21.4935 31.1464 21.4935H25.2786C24.5013 21.4935 23.8155 22.0698 23.7689 22.8472C23.7329 23.6606 24.3812 24.3479 25.1961 24.3479H31.4105C32.0963 24.3479 32.6081 24.9241 32.5991 25.61C32.5991 25.619 32.5991 25.619 32.5991 25.628C32.5991 25.637 32.5991 25.637 32.5991 25.646C32.6081 26.3318 32.0963 26.9081 31.4105 26.9081H24.908C24.1396 26.9081 23.4538 27.4843 23.4073 28.2527C23.3712 29.0766 24.0196 29.7534 24.8344 29.7534H26.5497C32.2269 28.5709 36.5024 23.533 36.5024 17.5152Z' fill='white'/%3E%3Cpath d='M19.2949 15.1953H22.0293C22.0293 13.8379 23.0938 12.8906 24.5 12.8906C25.7695 12.8906 26.6387 13.75 26.6387 14.8828C26.6387 15.8594 26.2383 16.5332 24.4512 18.252L19.4609 22.9785V25H29.7051V22.6562H23.3184V22.5977L26.2773 19.7656C28.6602 17.4902 29.5098 16.4258 29.5098 14.6973C29.5098 12.3535 27.5176 10.5957 24.5 10.5957C21.4434 10.5957 19.2949 12.4805 19.2949 15.1953Z' fill='%23777575'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0'%3E%3Crect width='48' height='48' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
  }
  .leaderboard-page .medal-3 {
    height: 48px;
    width: 48px;
    background-repeat: no-repeat;
    background-image: url("data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cg clip-path='url(%23clip0)'%3E%3Cpath d='M14.1958 20.752L3.71338 40.5012L13.2323 39.6218L17.8395 47.9987L28.3219 28.2495L14.1958 20.752Z' fill='%23219653'/%3E%3Cpath d='M15.3967 42.2492C15.6908 41.6174 15.3832 40.8626 14.7679 40.5354L14.1646 40.2142C13.5613 39.8706 13.3317 39.1067 13.6604 38.4884C13.9935 37.8596 14.7769 37.6195 15.4057 37.9527L17.1105 38.8576C17.6372 39.1367 18.2975 38.9341 18.5692 38.4044L18.6112 38.3234C18.9233 37.8236 18.7387 37.1633 18.2195 36.8887L13.1201 34.1829C12.4988 33.8528 12.1942 33.1009 12.4838 32.4676C12.8035 31.7938 13.6108 31.5282 14.2606 31.8733L18.9909 34.384C19.5176 34.6631 20.1779 34.4606 20.4571 33.9338L20.4841 33.8648L20.4916 33.8498C20.7932 33.2975 20.5816 32.6042 20.0248 32.3085L17.3716 30.9009C16.7503 30.5707 16.4457 29.8189 16.7398 29.1781C17.0565 28.5118 17.8668 28.2386 18.5166 28.5838L21.4475 30.14C21.9953 30.4312 22.6496 30.188 22.9332 29.6358C22.9377 29.6283 22.9377 29.6283 22.9407 29.6208C22.9452 29.6133 22.9452 29.6133 22.9482 29.6058C23.2469 29.061 23.0818 28.3827 22.5325 28.0931L19.3705 26.4153C18.7568 26.0896 18.4521 25.3378 18.7417 24.7045C19.0614 24.0307 19.8688 23.765 20.5186 24.1102L28.3192 28.2506L17.8368 47.9999L14.948 42.7489C15.1341 42.6229 15.2961 42.4668 15.3967 42.2492Z' fill='%2327AE60'/%3E%3Cpath d='M33.8043 20.752L44.2868 40.5012L34.7678 39.6218L30.1606 47.9987L19.6782 28.2495L33.8043 20.752Z' fill='%2327AE60'/%3E%3Cpath d='M32.6037 42.2477C32.3096 41.6159 32.6173 40.8611 33.2325 40.5339L33.8358 40.2127C34.4391 39.8691 34.6687 39.1052 34.3401 38.4869C34.0069 37.8581 33.2235 37.618 32.5947 37.9512L30.8899 38.8561C30.3632 39.1352 29.7029 38.9326 29.4313 38.4029L29.3892 38.3219C29.0771 37.8221 29.2617 37.1618 29.7809 36.8872L34.8818 34.1799C35.5031 33.8498 35.8077 33.0979 35.5181 32.4646C35.1985 31.7908 34.3911 31.5252 33.7413 31.8703L29.0111 34.381C28.4843 34.6601 27.824 34.4576 27.5449 33.9308L27.5179 33.8618L27.5104 33.8468C27.2087 33.2945 27.4203 32.6012 27.9771 32.3055L30.6303 30.8979C31.2516 30.5677 31.5563 29.8159 31.2621 29.1751C30.9455 28.5088 30.1351 28.2356 29.4853 28.5808L26.5514 30.14C26.0037 30.4312 25.3493 30.188 25.0657 29.6358C25.0612 29.6283 25.0612 29.6283 25.0582 29.6208C25.0537 29.6133 25.0537 29.6133 25.0507 29.6058C24.7521 29.061 24.9171 28.3827 25.4664 28.0931L28.6284 26.4153C29.2422 26.0896 29.5468 25.3378 29.2572 24.7045C28.9375 24.0307 28.1302 23.765 27.4803 24.1102L19.6797 28.2506L30.1621 47.9999L33.051 42.7489C32.8664 42.6214 32.7043 42.4653 32.6037 42.2477Z' fill='%23219653'/%3E%3Cpath d='M24.0001 35.0294C33.6732 35.0294 41.5147 27.1878 41.5147 17.5147C41.5147 7.8416 33.6732 0 24.0001 0C14.327 0 6.48535 7.8416 6.48535 17.5147C6.48535 27.1878 14.327 35.0294 24.0001 35.0294Z' fill='%23CD7F32'/%3E%3Cpath d='M26.3754 15.5051H15.2762C14.4133 15.5051 13.705 14.7968 13.705 13.9339L13.717 13.8258V13.8018C13.705 12.8909 14.4478 12.1465 15.3603 12.1465H23.0529C24.0718 12.1465 24.9723 11.3917 25.0323 10.3712C25.0803 9.3042 24.2294 8.40378 23.1609 8.40378H15.0121C14.1132 8.40378 13.4409 7.64892 13.4529 6.7485C13.4529 6.73649 13.4529 6.73649 13.4529 6.72449C13.4529 6.71248 13.4529 6.71248 13.4529 6.70048C13.4409 5.80156 14.1117 5.0452 15.0121 5.0452H23.5391C24.5461 5.0452 25.4465 4.29035 25.5065 3.28188C25.5545 2.20287 24.7036 1.31445 23.6351 1.31445H17.3907C11.0232 3.93918 6.53613 10.2001 6.53613 17.5145C6.53613 24.829 11.0232 31.0884 17.3922 33.7101H25.3204C26.3274 33.7101 27.2278 32.9553 27.2878 31.9468C27.3359 30.8678 26.485 29.9809 25.4165 29.9809L16.3972 29.9794C15.3332 29.9794 14.4763 29.0895 14.5334 28.012C14.5859 27.0035 15.4923 26.2456 16.5023 26.2456H19.9989C21.0044 26.2171 21.8163 25.3932 21.8163 24.3803C21.8163 23.3493 20.9774 22.5089 19.9449 22.5089H14.6444C13.7815 22.5089 13.0732 21.8021 13.0852 20.9376V20.8056C13.0252 19.9547 13.7095 19.2344 14.5604 19.2344H26.2674C27.2863 19.2344 28.1868 18.4795 28.2468 17.471C28.2948 16.3935 27.4424 15.5051 26.3754 15.5051Z' fill='%23B86D23'/%3E%3Cpath d='M23.9999 30.0149C17.1057 30.0149 11.4976 24.4053 11.4976 17.5126C11.4976 10.6198 17.1057 5.01172 23.9999 5.01172C30.8942 5.01172 36.5023 10.6213 36.5023 17.5141C36.5023 24.4068 30.8942 30.0149 23.9999 30.0149Z' fill='%23FFBC79'/%3E%3Cpath opacity='0.2' d='M36.5024 17.5152C36.5024 10.8641 31.2769 5.424 24.7174 5.04883H23.5528C22.7845 5.04883 22.0987 5.6251 22.0521 6.39346C22.0161 7.21584 22.6644 7.89416 23.4793 7.89416L30.3585 7.89566C31.1704 7.89566 31.8232 8.57398 31.7797 9.39637C31.7392 10.1662 31.0488 10.744 30.2775 10.744H27.6107C26.8439 10.7665 26.2241 11.3938 26.2241 12.1667C26.2241 12.953 26.8649 13.5938 27.6512 13.5938H31.6941C32.3529 13.5938 32.8917 14.1341 32.8827 14.7914V14.8904C32.9277 15.5402 32.407 16.088 31.7572 16.088H22.8295C22.0521 16.088 21.3663 16.6643 21.3198 17.4326C21.2838 18.255 21.9321 18.9333 22.747 18.9333H31.2109C31.8697 18.9333 32.4085 19.4736 32.4085 20.1309L32.3995 20.2134V20.2314C32.4085 20.9263 31.8412 21.4935 31.1464 21.4935H25.2786C24.5013 21.4935 23.8155 22.0698 23.7689 22.8472C23.7329 23.6606 24.3812 24.3479 25.1961 24.3479H31.4105C32.0963 24.3479 32.6081 24.9241 32.5991 25.61C32.5991 25.619 32.5991 25.619 32.5991 25.628C32.5991 25.637 32.5991 25.637 32.5991 25.646C32.6081 26.3318 32.0963 26.9081 31.4105 26.9081H24.908C24.1396 26.9081 23.4538 27.4843 23.4073 28.2527C23.3712 29.0766 24.0196 29.7534 24.8344 29.7534H26.5497C32.2269 28.5709 36.5024 23.533 36.5024 17.5152Z' fill='white'/%3E%3Cpath d='M22.6055 18.7988H24.2168C25.9258 18.7988 26.9316 19.5605 26.9219 20.9277C26.9219 22.1191 25.9062 22.9395 24.4316 22.9395C22.8789 22.9395 21.8633 22.1582 21.7656 21.0059H18.9531C19.0801 23.5938 21.248 25.3125 24.4316 25.3125C27.7031 25.3125 29.9199 23.6133 29.9199 21.0547C29.9199 19.1211 28.5527 17.8809 26.4629 17.6855V17.627C28.123 17.2852 29.4023 16.123 29.4023 14.3262C29.4023 12.0703 27.3906 10.5957 24.4121 10.5957C21.4629 10.5957 19.4121 12.2461 19.2656 14.8242H21.9707C22.0586 13.6035 23.0254 12.8613 24.4121 12.8613C25.8184 12.8613 26.6094 13.5938 26.6094 14.7461C26.6094 15.8984 25.6523 16.6992 24.1777 16.6992H22.6055V18.7988Z' fill='%23B86D23'/%3E%3C/g%3E%3Cdefs%3E%3CclipPath id='clip0'%3E%3Crect width='48' height='48' fill='white'/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A");
  }
  .leaderboard-page .player .action__wrapper {
    display: flex;
    align-items: center;
    height: inherit;
  }

  .leaderboard-page .player .season-exp {
    color: #445058;
    font-size: 21px;
    line-height: 25px;
  }
  .my-position {
    width: 100%;
    height: 56px;
    background: rgba(255, 255, 255, 0.5);
    position: absolute;
    top: unset;
    bottom: calc(50px + var(--f7-safe-area-bottom));
    z-index: 999;
    -webkit-backdrop-filter: saturate(180%) blur(10px);
    backdrop-filter: saturate(180%) blur(10px);
  }
  .my-position ul {
    background: transparent;
    height: inherit;
  }
  .my-position ul li {
    height: inherit;
    display: flex;
    align-items: center;
  }
  .my-position .player {
    height: 56px;
  }
  .my-position .player .avatar {
    border: unset;
  }
  .my-position .player .place {
    width: 35px;
  }
  .my-position .player .name {
    font-weight: 600;
    font-size: 17px;
    line-height: 22px;
    color: #007AFF;
    margin-left: 15px;
  }
  .flew-up {
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
    border-radius: 15px;
    margin-right: 12px;
  }
  .my-position .player .action__wrapper .season-exp {
    font-size: 21px;
    line-height: 25px;
    color: #007AFF;
  }

  @media (min-width: 321px) {
    .leaderboard-page .page-content .season-winners__wrapper .block.winners-row {
      gap: 12px;
    }
  }
  @media (min-width: 376px) {
    .leaderboard-page .page-content .season-winners__wrapper .block.winners-row {
      gap: 16px;
    }
  }
  /* #view-leaderboard .navbar:after {
    content: var(--f7-navbar-content) !important;
  } */
`,
  styleScoped: false
};
    